import * as React from 'react';
import { stylesheetSingleton } from "./singleton";
export var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles) {
        React.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, []);
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-style-singleton/dist/es2015/hook.js
// module id = 185
// module chunks = 0